import { Animator2DBase } from "./Animator2DBase";
import { AnimatorPlayState2D } from "./AnimatorPlayState2D";
import { AnimatorState2D } from "./AnimatorState2D";
export class AnimatorClip2D extends Animator2DBase {
    constructor() {
        super();
        this._clip = null;
        this._playStateInfo = new AnimatorPlayState2D();
        this._clipState = new AnimatorState2D();
        this._defaultWeight = 1;
        this._additive = false;
        this._autoPlay = true;
        this._clipState.name = "ClipState";
        this._clipState.clipStart = 0;
        this._clipState.clipEnd = 1;
        this._playStateInfo._currentState = this._clipState;
    }
    get clip() {
        return this._clip;
    }
    set clip(value) {
        if (this._clip === value)
            return;
        if (this._clip) {
            this._clip._removeReference(1);
            this._clipState.clip = null;
        }
        this._clip = value;
        if (value) {
            value._addReference(1);
            this._clipState.clip = value;
            const clipDuration = value._duration * (this._clipState.clipEnd - this._clipState.clipStart);
            this._playStateInfo._resetPlayState(0, clipDuration);
        }
    }
    get defaultWeight() {
        return this._defaultWeight;
    }
    set defaultWeight(v) {
        this._defaultWeight = v;
    }
    get additive() {
        return this._additive;
    }
    set additive(v) {
        this._additive = v;
    }
    get autoPlay() {
        return this._autoPlay;
    }
    set autoPlay(v) {
        this._autoPlay = v;
    }
    get loop() {
        return this._clipState.loop;
    }
    set loop(v) {
        this._clipState.loop = v;
    }
    get yoyo() {
        return this._clipState.yoyo;
    }
    set yoyo(v) {
        this._clipState.yoyo = v;
    }
    play(normalizedTime) {
        if (!this._clip)
            return;
        const clipDuration = this._clip._duration;
        const calclipduration = clipDuration * (this._clipState.clipEnd - this._clipState.clipStart);
        this._updateDefVal();
        const startTime = normalizedTime != null ? clipDuration * normalizedTime : 0;
        this._playStateInfo._resetPlayState(startTime, calclipduration);
        if (normalizedTime != null) {
            this._playStateInfo._normalizedPlayTime = normalizedTime;
        }
        this._isPlaying = true;
        this._clipState._eventStart(this, 0);
    }
    stop() {
        this._isPlaying = false;
    }
    gotoAndStop(normalizedTime) {
        if (!this._clip)
            return;
        const clipDuration = this._clip._duration;
        const calclipduration = clipDuration * (this._clipState.clipEnd - this._clipState.clipStart);
        this._updateDefVal();
        this._playStateInfo._resetPlayState(clipDuration * normalizedTime, calclipduration);
        this._playStateInfo._normalizedPlayTime = normalizedTime;
        this._isPlaying = false;
        this._updateClipDatas(this._clipState, this._additive, this._playStateInfo);
        this._setClipDatasToNode(this._clipState, this._additive, this._defaultWeight);
    }
    gotoAndStopByFrame(frame) {
        if (!this._clip)
            return;
        const allFrame = this._clip._duration * this._clip._frameRate;
        let normalizedTime = frame / allFrame;
        if (normalizedTime > 1)
            normalizedTime = 1;
        this.gotoAndStop(normalizedTime);
    }
    onEnable() {
        if (this._autoPlay && this._clip) {
            this.play();
        }
        else
            this._isPlaying = false;
    }
    onUpdate() {
        if (!this._isPlaying || !this._clip)
            return;
        const delta = this.owner.timer.delta / 1000.0;
        const appliedDelta = this._applyUpdateMode(delta);
        if (this.speed === 0 || appliedDelta === 0)
            return;
        const animatorState = this._clipState;
        const playStateInfo = this._playStateInfo;
        const speed = this.speed * animatorState.speed;
        const finish = playStateInfo._finish;
        let loop = animatorState.loop;
        if (loop <= -1) {
            if (this._clip.islooping)
                loop = 0;
            else
                loop = 1;
        }
        const dir = playStateInfo._frontPlay ? 1 : -1;
        const elapsed = appliedDelta * speed * dir;
        if (finish) {
            this._updateStateFinish(animatorState, playStateInfo);
        }
        else {
            this._updatePlayerTime(animatorState, playStateInfo, elapsed, loop);
        }
        this._updateClipDatas(animatorState, this._additive, playStateInfo);
        if (!finish) {
            this._setClipDatasToNode(animatorState, this._additive, this._defaultWeight);
            this._updateEventScript(animatorState, playStateInfo);
        }
        this._updateStateFinish(animatorState, playStateInfo);
    }
    onDestroy() {
        this.clip = null;
        this._playStateInfo._currentState = null;
        this._clipState.destroy();
        super.onDestroy();
    }
}
